import { render, staticRenderFns } from "./AtencionAuditoriaComentarios.vue?vue&type=template&id=0e26758a"
import script from "./AtencionAuditoriaComentarios.vue?vue&type=script&lang=js"
export * from "./AtencionAuditoriaComentarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports